import { render, staticRenderFns } from "./ItemEditActions.vue?vue&type=template&id=2d6c8b25"
import script from "./ItemEditActions.vue?vue&type=script&lang=js"
export * from "./ItemEditActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports